enum NotificationRuleConditionFields {
	Area = 0,
    EventOutcome = 1,
    Priority = 2
}

export default NotificationRuleConditionFields;